export const createNewEventStyle = {
	wrapper: {
		maxWidth: '970px',
		width: '100%',
		margin: '0 auto',
	},

	stepper: {
		width: '100%',
		margin: '40px 0',
		textTransform: 'capitalize',

		'& .MuiTypography-root': {
			lineHeight: '28px',
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 20px',
			width: '100%',

			'& > div': {
				maxWidth: '370px',
				margin: '0 auto',

				'&> div svg path': {
					fill: 'var(--success-500)',
				},
			},
		},
	},
};
